import React, { Component } from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import { getBookingPath } from 'lib/paths'
import { STEP_CAPACITY } from 'constants/booking'
import { RESERVATION_TYPE_INSTANT_BOOKING } from 'constants/reservation'
import TextButton from 'components/Luxkit/Button/TextButton'

const ButtonsWrapper = styled.div`
  text-align: center;

  > * + * {
    margin-top: ${rem(16)};
  }
`

interface Props {
  packageId: string;
  offerId: string;
  numberOfNights: number;
  className?: string;
  flightOrigin?: string;
  showFlights?: boolean;
  memberId?: string;
  accountAccessShowLogin?: (val: string) => void
}

class FlashTourBuyButtons extends Component<React.PropsWithChildren<Props>> {
  showRegisterModal = () => {
    const {
      packageId,
      offerId,
      numberOfNights,
      flightOrigin,
      showFlights,
      accountAccessShowLogin,
    } = this.props

    const bookingPath = getBookingPath(STEP_CAPACITY, {
      reservationType: RESERVATION_TYPE_INSTANT_BOOKING,
      originAirportCode: showFlights ? flightOrigin : undefined,
      packageId,
      offerId,
      numberOfNights,
    })

    accountAccessShowLogin(bookingPath)
  }

  render() {
    const {
      packageId,
      offerId,
      numberOfNights,
      className,
      flightOrigin,
      showFlights,
      memberId,
      accountAccessShowLogin,
    } = this.props

    const bookingPath = getBookingPath(STEP_CAPACITY, {
      reservationType: RESERVATION_TYPE_INSTANT_BOOKING,
      originAirportCode: showFlights ? flightOrigin : undefined,
      packageId,
      offerId,
      numberOfNights,
    })

    return (
      <ButtonsWrapper className={className}>
        <TextButton
          kind="primary"
          fit="flex"
          data-testid="HotelBookingBtn"
          {...(!memberId && accountAccessShowLogin ? { onClick: this.showRegisterModal } : { to: bookingPath })}
        >
          Check availability
        </TextButton>
      </ButtonsWrapper>
    )
  }
}

export default FlashTourBuyButtons
